export interface PortfolioMandateType {
  id?: string;
  description?: string;
  shortDescription?: string;
  mandateTypeEnum?: MandateTypeEnum;
}

export const MandateTypeEnum = {
  DISCRETIONARY: 'DISCRETIONARY',
  ADVISORY: 'ADVISORY',
  EXECUTION_ONLY: 'EXECUTION_ONLY',
  ADMINISTRATIVE: 'ADMINISTRATIVE',
  NOT_MANAGED: 'NOT_MANAGED'
} as const;

export type PortfolioMandateTypeEnum = typeof MandateTypeEnum;
export type MandateTypeEnum = PortfolioMandateTypeEnum[keyof PortfolioMandateTypeEnum];
